import { render, staticRenderFns } from "./EditPage.vue?vue&type=template&id=108e5f7f&scoped=true&"
import script from "./EditPage.vue?vue&type=script&lang=js&"
export * from "./EditPage.vue?vue&type=script&lang=js&"
import style0 from "./EditPage.vue?vue&type=style&index=0&id=108e5f7f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108e5f7f",
  null
  
)

export default component.exports